
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import backButtonOutlined from "../common/back-button-outlined.vue";
import ReportDownload from "./report-download.vue";
import ReportHeaderChannelSelector from "./report-header-channel-selector.vue";
import ReportHeaderDateRangeSelector from "./report-header-date-range-selector.vue";
import ReportHeaderOutletSelector from "./report-header-outlet-selector.vue";
import ReportOrderFilter from "./report-order-filter.vue";
import ReportOrdersSearch from "./report-orders-search.vue";
import ReportPrint from "./report-print.vue";
import ReportItemWiseSalesDisplayCategorySwitch from "./report-item-wise-sales-display-category-switch.vue";

export default {
  components: {
    backButtonOutlined,
    ReportHeaderOutletSelector,
    ReportHeaderChannelSelector,
    ReportHeaderDateRangeSelector,
    ReportDownload,
    ReportPrint,
    ReportOrdersSearch,
    ReportOrderFilter,
    ReportItemWiseSalesDisplayCategorySwitch
  },
  data() {
    return {
      LOAD_REQUEST_DELAY: 100,
      requestTimeout: 0
    };
  },
  props: {
    title: {
      default: ""
    },
    payments: {
      type: Array,
      default: () => []
    },
    stages: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.fetchReport(true, true);
  },
  computed: {
    ...mapState("report", [
      "reportOrders",
      "selectedTimeRange",
      "selectedStartDate",
      "selectedEndDate"
    ]),
    ...mapGetters("restaurant", ["hasMultipleBrands"])
  },
  methods: {
    ...mapActions("report", ["getOverallSalesReport"]),
    ...mapMutations("report", ["SET_DATE_TIME_RANGE", "SET_REPORT_PRODUCTS"]),

    fetchReport(backgroundLoad = true, force = true) {
      clearTimeout(this.requestTimeout);
      this.requestTimeout = setTimeout(
        (() => {
          this.$nuxt.$emit("order-filter-changed");
          this.getOverallSalesReport({ backgroundLoad, force }).catch((err) => {
            this.$nuxt.$emit("show-error-toast", err);
          });
        }).bind(this),
        this.LOAD_REQUEST_DELAY
      );
    },
    handleSeachInputChange(input) {
      this.$emit("search-input-changed", input);
    },
    handleDateRangeChange(payload) {
      this.SET_DATE_TIME_RANGE(payload.dateRangeSelected);
      if (payload.force) this.SET_REPORT_PRODUCTS([]);
    },
    handleDisplayCategoryToggle(switchStatus) {
      this.$emit("display-category-toggled", switchStatus);
    }
  }
};
